var _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgThunderPro = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_12_1",
    "data-name": "Component 12 \\u2013 1",
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_237",
    "data-name": "Rectangle 237",
    fill: "#ff6057",
    stroke: "#ff766f",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    rx: 5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 9.5,
    height: 9.5,
    rx: 4.75,
    fill: "none"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_728951_electricity_lightning_charge_electric_forecast_icon",
    "data-name": "728951_electricity_lightning_charge_electric_forecast_icon",
    d: "M23.779,2.053h-.805L24.093.532a.315.315,0,0,0,.019-.351A.385.385,0,0,0,23.779,0H21.89a.386.386,0,0,0-.328.172l-1.511,2.4a.314.314,0,0,0,0,.341.386.386,0,0,0,.327.17h1.238L20.428,4.963a.322.322,0,0,0,.1.442.4.4,0,0,0,.229.07.4.4,0,0,0,.267-.1l3.023-2.737a.319.319,0,0,0,.082-.373A.381.381,0,0,0,23.779,2.053Z",
    transform: "translate(-17.079 2.262)",
    fill: "#fff"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgThunderPro, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/thunderPro.fd4883f0.svg";
export { ForwardRef as ReactComponent };